// Triggers a browser download for a Blob (e.g. a streamed CSV from the API).
export function downloadBlob(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Revoke on the next tick so the download has a chance to start.
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
}

// Extracts a filename from a Content-Disposition header, falling back to a default.
export function filenameFromContentDisposition(header: string | undefined, fallback: string): string {
  if (!header) return fallback;
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(header);
  return match && match[1] ? decodeURIComponent(match[1]) : fallback;
}
